import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { parseRoute, routePath } from './utils/navigation';

const legacyRoute = window.location.hash.startsWith('#/');
if (legacyRoute) window.history.replaceState(null, '', routePath(parseRoute(window.location.hash)));
const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
if (container.dataset.prerendered && !legacyRoute) ReactDOM.hydrateRoot(container, app);
else ReactDOM.createRoot(container).render(app);
